import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const FAQS = [{
  q: '¿Necesito bloquearle para que funcione?',
  a: 'El protocolo te enseña a desanclarte independientemente de lo que ellos hagan, aunque te sugerimos higiene digital profunda.'
}, {
  q: '¿Es una novela o una guía?',
  a: 'Es una narrativa terapéutica: historias profundas que sirven de espejo, seguidas de herramientas de psicología práctica.'
}, {
  q: '¿Me servirá si han pasado meses?',
  a: 'Sí, el duelo ambiguo puede durar años si no se cierra correctamente. Nunca es tarde para recuperar tu energía.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-midnight py-24" data-id="element-3">
      <div className="mx-auto max-w-3xl px-6" data-id="element-4">
        <Reveal data-id="element-5">
          <h2 className="text-center font-display text-3xl font-semibold text-cream sm:text-4xl" data-id="element-6">
            Preguntas frecuentes
          </h2>
        </Reveal>

        <div className="mt-12 space-y-4" data-id="element-7">
          {FAQS.map((faq, i) => {
          const isOpen = open === i;
          return <Reveal key={faq.q} delay={i * 0.06} data-id="element-8">
                <div className="overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03]" data-id="element-9">
                  <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left" data-id="element-10">
                    <span className="font-display text-lg font-medium text-cream" data-id="element-11">
                      {faq.q}
                    </span>
                    <motion.span animate={{
                  rotate: isOpen ? 45 : 0
                }} transition={{
                  duration: 0.25
                }} data-id="element-12">
                      <PlusIcon className="h-5 w-5 flex-none text-rose-glow" data-id="element-13" />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false} data-id="element-14">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: [0.22, 1, 0.36, 1]
                }} data-id="element-15">
                        <p className="px-6 pb-6 leading-relaxed text-muted" data-id="element-16">
                          {faq.a}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}